import { reduxForm } from 'redux-form'
import { goBack } from 'react-router-redux'
import at from 'lodash/at'

import { fetchWorkOrder } from '../../actions/work-orders'
import { fetchServicing, addServices } from '../../actions/servicings'
import { fetchServicesForWorkOrder } from '../../actions/services'

import WorkSummaryAddServices from '../../components/work-summaries/work-summary-add-services'

const fields = [
  'serviceIds'
]

function mapStateToProps (state, ownProps) {
  const orderedServices = at(state.services, state.services.ids || [])
  const servicing = state.servicings[ownProps.params.servicingId]

  const serviceIds = servicing ? servicing.services : []

  return {
    modalTitle: 'Add Services',
    initialValues: {
      serviceIds,
    },
    services: orderedServices,
    servicing,
  }
}

function mapDispatchToProps (dispatch, { params: { workSummaryId, servicingId } }) {
  dispatch(fetchWorkOrder(workSummaryId))
  dispatch(fetchServicing(servicingId))
  dispatch(fetchServicesForWorkOrder(workSummaryId))

  return {
    onSubmit (data) {
      return dispatch(addServices(servicingId, data))
        .then((action) => {
          if (action.error) {
            const { payload: { errors: [{ detail: _error }] } } = action
            return Promise.reject({ _error })
          } else {
            dispatch(goBack())
          }
        })
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'workSummaryAddServices'
  },
  mapStateToProps,
  mapDispatchToProps
)(WorkSummaryAddServices)



// WEBPACK FOOTER //
// ./src/containers/work-summaries/work-summary-add-services-container.js